import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { minifyXML } from '../Conversion/Minifiers';
import RandomContent from '../Components/RandomContent';
import ConversionActions from '../Common/ConversionActions';
import { GetRandomBlogPost, GetPageContentBySlug } from '../services/apiservice';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { xmlMinifierFAQ } from '../Seo/faqSchemas';

const XmlMinifier = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
  const [tabSpace, setTabSpace] = useState(2);
  const [randomPost, setRandomPost] = useState('');
  const [loadingPost, setLoadingPost] = useState(true);
  const [pageContent, setPageContent] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const handleBlogClick = () => navigate('/blog/:paramlink');

  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
    fetchRandomPost();
    fetchPageContent();
  }, []);

  const handleConversion = () => {
    const { minified, isError } = minifyXML(inputData);
    setOutputData(minified);
    setIsError(isError);
  };

  const fetchRandomPost = async () => {
    setLoadingPost(true);
    try {
      const randomPostData = await GetRandomBlogPost();
      const jsonPostList = JSON.parse(randomPostData);
      setRandomPost(jsonPostList);
      setLoadingPost(false);
    } catch (error) {
      setLoadingPost(false);
      console.error('Error fetching the data:', error);
    }
  };

  const fetchPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
        console.log(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  return (
    <><div>
      <Header />

      <Helmet>
        <title>{pageContent?.section1header || "Free Online XML Minifier - Compress XML - Data Beautifier"}</title>
        <meta name="description" content="Minify your XML files by removing unnecessary spaces and formatting. Optimize your data for faster processing and reduced file size instantly." />
        <link rel="canonical" href={`https://databeautifier.com/${paramlink}`} />
        <meta property="og:title" content={pageContent?.section1header} />
        <meta property="og:url" content={`https://databeautifier.com/${paramlink}`} />
        <script type="application/ld+json">
          {JSON.stringify(xmlMinifierFAQ)}
        </script>
      </Helmet>

      <RandomContent />

            {/* Page Intro (Section 1) */}
            <div className="blog-area">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">{pageContent?.section1header}</a></h4>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          pageContent?.section1text && pageContent.section1text.trim() !== ""
                                            ? pageContent.section1text
                                            : `Optimize your XML files with ease using Data Beautifier's Free XML Minifier Online Tool. Our Best XML Minifier Online Tool compresses your XML data by removing unnecessary spaces, line breaks, and formatting, ensuring a smaller, faster, and cleaner file. Designed for simplicity, our Simple XML Minifier Tool requires no technical expertise, making it perfect for developers and data managers alike. With the Easy XML Minifier Tool, you can enhance your workflow in just a few clicks. Accessible anytime and completely free, Data Beautifier provides reliable results for all your XML compression needs. Try it today!`,
                                      }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            

      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up"
                data-aos-duration="2800">
                <div className="thumb">
                  <Inputs
                    value={inputData}
                    setValue={(val) => {
                      setInputData(val);
                      setIsError(false); // Reset error on change
                    }}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    isError={isError}
                    lineCol={inputLnCol}
                    setLineCol={setInputLnCol}
                    readOnly={false}
                    idPrefix="input" />
                </div>
              </div>
            </div>

            {/* Conversion Actions */}
            <ConversionActions
              tabSpace={tabSpace}
              setTabSpace={setTabSpace}
              handleConversion={handleConversion}
              outputData={outputData}
              randomPost={randomPost}
              loadingPost={loadingPost}
              handleBlogClick={handleBlogClick}
              isError={isError}
              buttonLabel="Minify XML"
              iconClass="ri-exchange-line"
            />

            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up"
                data-aos-duration="1200">
                <div className="thumb">
                  <Output
                    value={outputData}
                    setValue={setOutputData}
                    lineCol={outputLnCol}
                    setLineCol={setOutputLnCol}
                    fontSize={fontSize}
                    isError={isError}
                    setFontSize={setFontSize}
                    idPrefix="output" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 Below Boxes */}
      {pageContent?.section2text &&
        pageContent.section2text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section2text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

    </div>

      <Footer />
    </>
  );
};

export default XmlMinifier;
